export const removeExtraSpans = (parsedDoc: Document) => {
  const spanElements = parsedDoc.querySelectorAll('span')

  spanElements.forEach((span) => {
    const styleAttribute = span.getAttribute('style')
    const attributesToCheck = ['background', 'font-weight', 'color', 'font-style', 'vertical-align']

    if (
      !styleAttribute ||
      attributesToCheck.every((attribute) => !styleAttribute.includes(attribute))
    ) {
      const fragment = document.createDocumentFragment()
      while (span.firstChild) {
        fragment.appendChild(span.firstChild)
      }
      span.parentNode?.replaceChild(fragment, span)
    }
  })
}
